import {
    minimalToast,
    NotificationCategory,
    NotificationPriority,
    NotificationSeverity,
} from "../../utils/toast";
import { AxiosRequest } from "../ApiCall";
import { configEnv } from "../constant";

export const postApi = {
    create: async (
        body: { text: string; files?: { url: string; title: string }[]; organizationId: string },
        header: any
    ) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/post/create-post`,
                body,
                header
            );
            minimalToast({
                title: "Create Post",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },

    getAll: async (header: any, offset: number = 0, limit: number = 20) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/post/get-all-posts?offset=${offset}&limit=${limit}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getAllPostByOrganization: async (id: string, header: any, offset: number = 0, limit: number = 20) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/post/get-all-posts-by-organization/${id}?offset=${offset}&limit=${limit}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getUserPosts: async (
        id: string,
        header: any,
        offset: number = 0,
        limit: number = 20,
        organizationId?: string
    ) => {
        try {
            const params = new URLSearchParams({
                offset: String(offset),
                limit: String(limit),
            });
            if (organizationId) params.set("organizationId", organizationId);
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/post/${id}?${params.toString()}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    /**
     * One post with comments, reaction summary and view count.
     * Unlike the rest of this file the error is rethrown: the detail page
     * needs to tell a 403 or 404 apart from a network failure.
     */
    getById: async (id: string, header: any) => {
        const data = await AxiosRequest(
            "GET",
            `${configEnv.baseUrl}/post/detail/${id}`,
            null,
            header,
            { silentError: true }
        );
        return data.data;
    },
    /**
     * Record that the caller opened a post. Fire-and-forget bookkeeping:
     * failures are swallowed and never toasted.
     */
    recordView: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/post/view/${id}`,
                null,
                header,
                { silentError: true }
            );
            return data.data;
        } catch (error: any) {
        }
    },
    /**
     * Record that the caller shared a post. Fire-and-forget like recordView:
     * a failure must never block the copy that the user actually asked for.
     */
    recordShare: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/post/share/${id}`,
                null,
                header,
                { silentError: true }
            );
            return data.data;
        } catch (error: any) {
        }
    },
    delete: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "DELETE",
                `${configEnv.baseUrl}/post/${id}`,
                null,
                header
            );
            minimalToast({
                title: "Delete Post",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    pin: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/post/pin-post/${id}`,
                null,
                header
            );
            minimalToast({
                title: "Pin Post",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    save: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/post/save-post/${id}`,
                null,
                header
            );
            minimalToast({
                title: "Save Post",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    comment: async (
        body: { comment: string; files?: { url: string; title: string }[]; postId: string },
        header: any
    ) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/post/comment`,
                body,
                header
            );
            minimalToast({
                title: "Comment Post",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
};
